import {
  OPEN_WIDGET,
  CLOSE_WIDGET,
  SET_VIEW,
  ATTACH_ENTITY,
  DETACH_ENTITY,
  OPEN_WITH_ENTITY,
  SET_PREFILLED_INPUT,
  SET_POSITION,
  RESET_POSITION,
  SET_OVERRIDE_SCOPE,
  CLEAR_OVERRIDE_SCOPE,
} from './actions'
import { initialState, persistOpen, persistPosition } from './state'

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case OPEN_WIDGET:
      persistOpen(true)
      return { ...state, open: true, anchorContext: action.payload.anchorContext || state.anchorContext }

    case CLOSE_WIDGET:
      persistOpen(false)
      return { ...state, open: false, entityAttachment: null, prefilledInput: '', overrideScope: null }

    case SET_VIEW:
      return { ...state, view: action.payload.view }

    case ATTACH_ENTITY:
      return { ...state, entityAttachment: action.payload.entityAttachment }

    case DETACH_ENTITY:
      return { ...state, entityAttachment: null }

    case OPEN_WITH_ENTITY:
      persistOpen(true)
      return {
        ...state,
        open: true,
        view: action.payload.view,
        anchorContext: action.payload.anchorContext || state.anchorContext,
        entityAttachment: action.payload.entityAttachment,
        prefilledInput: action.payload.prefilledInput,
      }

    case SET_PREFILLED_INPUT:
      return { ...state, prefilledInput: action.payload.prefilledInput }

    case SET_POSITION:
      persistPosition(action.payload.position)
      return { ...state, position: action.payload.position }

    case RESET_POSITION:
      persistPosition(null)
      return { ...state, position: null }

    case SET_OVERRIDE_SCOPE:
      return { ...state, overrideScope: action.payload.scope }

    case CLEAR_OVERRIDE_SCOPE:
      return { ...state, overrideScope: null }

    default:
      return state
  }
}
